import {useParams} from "react-router-dom";
import BPPForm from "../Forms/BPPForm/BPPForm";

interface FormEntry {
    formEntryId?: number;
    isAdminPreview?: boolean;
    formId?: number;
}
export default function BPPFormEntry(props: FormEntry): JSX.Element {
    const { isAdminPreview, formEntryId, formId } = props;
    const { formEntryIdParams } = useParams();

    return <>
        <BPPForm
            formId={formId}
            isAdminPreview={isAdminPreview}
            formEntryId={formEntryIdParams ? parseInt(formEntryIdParams) : formEntryId} />
    </>
}
